<!-- 输入手机号-->
<template>
  <div>
    <p>账号</p>
    <div class="input">
      <div class="phone" :style="{borderColor:color?'red':'#dedede'}">
        <!-- <div class="arrowhead" @click="show=!show">
          +{{value}}
          <img
            src="@/assets/img/position/into.png"
            class="arrowheads"
            :style="{ transform:show?' rotate(-90deg)':' rotate(90deg)'}"
          />
        </div> -->
        <input
          type="text"
          class="tel"
          @focus="color=true"
          @blur="color=false"
          placeholder="请输入登录账号"
          v-model="telpone"
        />
      </div>
    </div>
    <ul :style="{height:show?'2rem':'0'}" class="tel-left">
      <li v-for="(item, index) in num" :key="index" @click="select(item)">+{{item}}</li>
    </ul>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  components: {},
  data() {
    return {
      color: false,
      colors: false,
      show: false,
      num: ["86", "96", "00",'10','56'],
      value: "86",
      mobile:''
    };
  },
  computed: {
      telpone:{
        get(){
          return this.mobile
        },
        set(val){
          var val=val.replace(/[, ]/g, "")
          this.mobile=val
          this.getTelphone(val)
        }
      }
  },
  methods: {
    ...mapMutations(['getTelphone']),
    select(val) {
      this.value = val;
      this.show = false;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
p {
  padding-bottom: 0.2rem;
  font-size: 0.28rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.input {
  .phone {
    font-size: 0.28rem;
    display: flex;
    border-bottom: 1px solid #dedede;
    padding: 0.2rem 0 0;
    align-items: center;
    justify-content: space-between;
    .show {
      width: 0.4rem;
      height: 0.4rem;
    }
    .password-input {
      width: 90%;
    }
    .arrowhead {
      display: flex;
      align-items: center;
      flex: 1;
      padding: 0.19rem 0;
      .arrowheads {
        width: 0.5rem;
        height: 0.6rem;
        transition: transform 1s;
      }
    }
    .tel {
      flex: 4;
    }
  }
}
.tel-left {
  box-sizing: border-box;
  position: absolute;
  z-index: 10;
  max-height: 2rem;
  width: 92%;
  overflow: auto;
  overflow-y: scroll;
  background: #fff;
  transition: height 1s;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 0.2rem;
  box-shadow: 0 0.05rem 0.05rem rgba(178, 178, 178, 0.8);
  font-size: 0.24rem;
  li {
    padding: 0.2rem 0;
  }
}
</style>